import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ClipboardList, Loader2, Plus, X } from "lucide-react";
import { newClient } from "@/lib/bf";
import BFConsentLinks from "./BFConsentLinks";

const FIELDS = [["salon", "Nume salon *"], ["admin_name", "Nume administrator"], ["phone", "Telefon *", "tel"], ["email", "E-mail", "email"], ["cui", "CUI"], ["city", "Oraș"], ["address", "Adresă salon"]];
const EMPTY = Object.fromEntries(FIELDS.map(([k]) => [k, ""]));

export default function BFNewClient() {
  const [open, setOpen] = useState(false);
  const [v, setV] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const save = (e) => {
    e.preventDefault();
    setBusy(true);
    newClient(v).then((d) => { setDone(d); setV(EMPTY); toast.success(d.existing ? `Salonul ${d.salon || ""} există deja în portofoliul tău` : "Fișă nouă creată"); })
      .catch((er) => toast.error(typeof er.response?.data?.detail === "string" ? er.response.data.detail : "Completează numele salonului și un telefon valid")).finally(() => setBusy(false));
  };
  if (!open) return <button type="button" className="st-btn st-btn--silver" onClick={() => { setOpen(true); setDone(null); }} data-testid="bf-new-client-open"><Plus size={15} /> Fișă client nouă</button>;
  return (
    <section className="invite-box" data-testid="bf-new-client">
      <h3>Fișă client nouă <button type="button" className="st-btn st-btn--ghost" onClick={() => setOpen(false)} aria-label="Închide" data-testid="bf-new-client-close"><X size={14} /></button></h3>
      {done ? (
        <>
          {done.consent && <BFConsentLinks c={done.consent} msg="Salon salvat la tine în portofoliu." />}
          <div className="share-actions">
            <Link className="st-btn st-btn--light" to={`/client/${done.id}`} data-testid="bf-new-client-card"><ClipboardList size={14} /> Completează fișa</Link>
            <button type="button" className="st-btn st-btn--ghost" onClick={() => setDone(null)} data-testid="bf-new-client-another"><Plus size={14} /> Încă un salon</button>
          </div>
        </>
      ) : (
        <form onSubmit={save} className="bfc-grid">
          {FIELDS.map(([k, l, t]) => (
            <label key={k} className={`st-field bfc-f ${k === "address" ? "is-wide" : ""}`}><span className="st-label">{l}</span>
              <input type={t || "text"} value={v[k]} onChange={(e) => setV({ ...v, [k]: e.target.value })} required={l.endsWith("*")} data-testid={`bf-new-client-${k}`} /></label>
          ))}
          <div className="bfc-f is-wide"><button type="submit" className="st-btn st-btn--silver" disabled={busy} data-testid="bf-new-client-save">{busy ? <Loader2 size={14} className="animate-spin" /> : <Plus size={14} />} Creează fișa</button></div>
        </form>
      )}
    </section>
  );
}
